export default __webpack_public_path__ + "media/zurb/img/playground/thumbtack-dashed-line-5e2d0e64fbebf0fd0be2490c85b01ea8.svg";